"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var conversionService = /*#__PURE__*/function () {
  function conversionService() {
    _classCallCheck(this, conversionService);
  }
  return _createClass(conversionService, null, [{
    key: "getEligibility",
    value: function getEligibility(userId, conversionApp) {
      return new Promise(function (resolve, reject) {
        var _JSON$parse;
        var accessObject = JSON.parse(JSON.stringify(window.sessionStorage.getItem('okta-token-storage')) || '{}');
        userId = userId ? userId : (_JSON$parse = JSON.parse(accessObject)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.accessToken) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.claims.sub;
        _axios["default"].post('/api/mytbi/eligibility/epay', {
          userId: userId,
          conversionApp: conversionApp
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getPremiumAuditEligibility",
    value: function getPremiumAuditEligibility(userId, conversionApp) {
      return new Promise(function (resolve, reject) {
        var _JSON$parse2;
        var accessObject = JSON.parse(JSON.stringify(window.sessionStorage.getItem('okta-token-storage')) || '{}');
        userId = userId ? userId : (_JSON$parse2 = JSON.parse(accessObject)) === null || _JSON$parse2 === void 0 || (_JSON$parse2 = _JSON$parse2.accessToken) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.claims.sub;
        _axios["default"].post('/api/mytbi/eligibility/premiumaudit', {
          userId: userId,
          conversionApp: conversionApp
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getRcLegacyEligibility",
    value: function getRcLegacyEligibility(userId, conversionApp) {
      return new Promise(function (resolve, reject) {
        var _JSON$parse3;
        var accessObject = JSON.parse(JSON.stringify(window.sessionStorage.getItem('okta-token-storage')) || '{}');
        userId = userId ? userId : (_JSON$parse3 = JSON.parse(accessObject)) === null || _JSON$parse3 === void 0 || (_JSON$parse3 = _JSON$parse3.accessToken) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.claims.sub;
        _axios["default"].post('/api/mytbi/eligibility/rcLegacy', {
          userId: userId,
          conversionApp: conversionApp
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getCurrentUser",
    value: function getCurrentUser() {
      return new Promise(function (resolve, reject) {
        _axios["default"].get('/api/auth/users/current').then(function (response) {
          if (response && response.status === 200) resolve(response.data);else reject('Unauth access is restricted');
        })["catch"](function (err) {
          reject(err);
        });
        resolve({});
      });
    }
  }, {
    key: "getSiteHealth",
    value: function getSiteHealth() {
      return new Promise(function (resolve, reject) {
        _axios["default"].get('/api/sitehealth').then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "completeConversion",
    value: function completeConversion(userId, token) {
      return new Promise(function (resolve, reject) {
        var _JSON$parse4;
        var accessObject = JSON.parse(JSON.stringify(window.sessionStorage.getItem('okta-token-storage')) || '{}');
        userId = userId ? userId : (_JSON$parse4 = JSON.parse(accessObject)) === null || _JSON$parse4 === void 0 || (_JSON$parse4 = _JSON$parse4.accessToken) === null || _JSON$parse4 === void 0 ? void 0 : _JSON$parse4.claims.sub;
        _axios["default"].post('/api/mytbi/conversion/epay', {
          userId: userId,
          token: token
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "completePremiumAuditConversion",
    value: function completePremiumAuditConversion(userId, token) {
      return new Promise(function (resolve, reject) {
        var _JSON$parse5;
        var accessObject = JSON.parse(JSON.stringify(window.sessionStorage.getItem('okta-token-storage')) || '{}');
        userId = userId ? userId : (_JSON$parse5 = JSON.parse(accessObject)) === null || _JSON$parse5 === void 0 || (_JSON$parse5 = _JSON$parse5.accessToken) === null || _JSON$parse5 === void 0 ? void 0 : _JSON$parse5.claims.sub;
        _axios["default"].post('/api/mytbi/conversion/premiumaudit', {
          userId: userId,
          token: token
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "completeRcLegacyConversion",
    value: function completeRcLegacyConversion(userId, token) {
      return new Promise(function (resolve, reject) {
        var _JSON$parse6;
        var accessObject = JSON.parse(JSON.stringify(window.sessionStorage.getItem('okta-token-storage')) || '{}');
        userId = userId ? userId : (_JSON$parse6 = JSON.parse(accessObject)) === null || _JSON$parse6 === void 0 || (_JSON$parse6 = _JSON$parse6.accessToken) === null || _JSON$parse6 === void 0 ? void 0 : _JSON$parse6.claims.sub;
        _axios["default"].post('/api/mytbi/conversion/rcLegacy', {
          userId: userId,
          token: token
        }).then(function (response) {
          resolve(response.data);
        })["catch"](function (err) {
          reject(err);
        });
      });
    }
  }]);
}();
var _default = exports["default"] = conversionService;